<script lang="ts">
export default {
  name: 'KkApprovalHistory',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import moment from 'moment'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

interface ApprovalNote {
  commenter_name: string
  commented_at: string
  kind: 'approver_comment' | 'applicant_comment'
  body: string
}

interface Props {
  height?: string
  approvalNotes? : ApprovalNote[] | []
}
const props = withDefaults(defineProps<Props>(), {
  height: '360px',
  approvalNotes: () => []
})

type Style = {
  height?: string
}
const containerStyled = computed<Style>(() => {
  const styles: Style = {}
  if (props.height) styles['height'] = props.height
  return styles
})

const formatDate = (dateStr: string): string => {
  return moment(dateStr).format(t('format.datetime.default'))
}
const noteHeader = (note: ApprovalNote): string => {
  if(note.commenter_name === '') {
    return t('pages.CompaniesReviews.ApprovalHistoryModal.status.batchRejectFormat', { commentedAt: formatDate(note.commented_at), commenterName: note.commenter_name })
  } else if (note.kind === 'approver_comment') {
    return t('pages.CompaniesReviews.ApprovalHistoryModal.status.approverFormat', { commentedAt: formatDate(note.commented_at), commenterName: note.commenter_name })
  } else {
    return t('pages.CompaniesReviews.ApprovalHistoryModal.status.applicantFormat', { commentedAt: formatDate(note.commented_at), commenterName: note.commenter_name })
  }
}
const noteBodyComment = (note: ApprovalNote): string => {
  if (note.body.length === 0) {
    if (note.kind === 'applicant_comment') {
      return t('pages.CompaniesReviews.ApprovalHistoryModal.status.requestedApproval')
    } else {
      return t('pages.CompaniesReviews.ApprovalHistoryModal.status.revertedApproval')
    }
  }
  return note.body
}
</script>
<template>
  <p class="approvalHistoryTitle">{{ t('pages.CompaniesReviews.ApprovalHistoryModal.title') }}</p>
  <div id="scroll" class="approvalHistoryContainer" :style="containerStyled">
    <div v-if="!props.approvalNotes || props.approvalNotes.length === 0" class="note">
      <h4>{{ t('pages.CompaniesReviews.ApprovalHistoryModal.emptyApprovalHistory') }}</h4>
    </div>
    <div v-else>
      <div v-for="(note, i) in props.approvalNotes" :key="i" class="note">
        <h4>
          {{ noteHeader(note) }}
        </h4>
        {{ noteBodyComment(note) }}
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.approvalHistoryTitle {
  font-size: 12px;
  font-weight: bold;
}
.approvalHistoryContainer {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  box-sizing: border-box;
  border-radius: 4px;
  overflow-y: scroll;
  box-shadow: 0 0 0 rgba(63, 63, 68, .05);
  height: 372px;

  .note {
    margin: 16px;
    padding: 0 0 10px;
    font-size: 12px;

    h4 {
      margin: 0;
    }
  }
}
</style>
